import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Select, Spin } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

type Permission = { id: number; name: string };
type Admin = {
    id: number;
    branch_name: string;
    is_wizklub: boolean;
    is_offline: boolean;
    branch: number;
};

type Agent = {
    id: number;
    username: string;
};

type Trainer = {
    id: number;
    username: string;
}

type State = {
    state_id: number,
    name: string,
    label: string,
}
type Zone = {
    zone_id: number,
    name: string,
    label: string,
}

type Branch = {
    branch_id: number,
    name: string,
    label: string,
}

const { Option } = Select;


const WizklubBranchWiseIntrestedData = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>("");
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [AsignshowCard, setAsignShowCard] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
    const [agentsLoading, setAgentsLoading] = useState(false);
    const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
    const [trainerDropdown, setTrainerDropdown] = useState<Trainer[]>([]);
    const [assignmentType, setAssignmentType] = useState<'agent' | 'trainer' | undefined>();
    const [dangerToastMessage, setDangerToastMessage] = useState("");
    const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
    const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
    const [states, setStates] = useState<State[]>([]);
    const [zones, setZones] = useState<Zone[]>([]);
    const [branches, setBranches] = useState<Branch[]>([]);
    const [selectedState, setSelectedState] = useState<number>(0);
    const [selectedZone, setSelectedZone] = useState<number>(0);
    const [selectedBranch, setSelectedBranch] = useState<number>(0);
    const [selectedTrainer, setSelectedTrainer] = useState<number>(0);
    const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(0);

    const handleClearState = () => setSelectedState(0);
    const handleClearZone = () => setSelectedZone(0);
    const handleClearBranch = () => setSelectedBranch(0);
    const handleClearTrainer = () => setSelectedTrainer(0);
    const handleClearAgent = () => setSelectedAgentFilter(0);

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        if (!checkPermission("change_wizklubbranchwiseinterestedstudentsdetails", "wizklubbranchwiseinterestedstudentsdetails")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer);
            //   fetchAgentsData();
            //   fetchTrainerData();
            fetchStates();
            fetchZones();
            fetchBranches(selectedState, selectedZone);
        }
    }, [userPermissions]);

    useEffect(() => {
        fetchZones();
        fetchBranches(selectedState, selectedZone);
    }, [selectedState, selectedZone])

    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const fetchAgentsData = async () => {
        setAgentsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
                options
            );
            const data = await response.json();
            setAgentsDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const fetchTrainerData = async () => {
        try {
            const response = await fetch(
                `${webApi}/wizklub/wizklub_trainers_dropdown/`,
                options
            );
            const data = await response.json();
            setTrainerDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    };

    const fetchStates = async () => {
        try {
            const response = await fetch(
                `${webApi}/branches/branches_state_dropdown/`,
                options
            );
            const data = await response.json();
            setStates(data.results);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    }

    const fetchZones = async () => {
        try {
            const response = await fetch(
                `${webApi}/branches/branches_zone_dropdown/${selectedState}/`,
                options
            );
            const data = await response.json();
            setZones(data.results);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    }

    const fetchBranches = async (state: any, zone: any) => {
        try {
            let url = `${webApi}/branches/wizklub_branches_dropdown/`;

            // Manually build query parameters
            let queryParams = [];

            if (state && state !== 0) {
                queryParams.push(`state_id=${state}`);
            }

            if (zone && zone !== 0) {
                queryParams.push(`zone_id=${zone}`);
            }

            if (queryParams.length > 0) {
                url += "?" + queryParams.join("&");
            }

            const response = await fetch(url, options);
            const data = await response.json();
            setBranches(data);
        } catch (error) {
            console.error("Failed to fetch branches", error);
        }
    };



    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchGroupsData = async (
        page: number,
        pageSize: number,
        searchText: string,
        state: number,
        zone: number,
        branch: number,
        agent: number,
        trainer: number,

    ) => {
        let apiUrl = `${webApi}/wizklub/wizklub_branch_wise_interested_students_details/?page=${page}&page_size=${pageSize}`
        if (searchText) apiUrl += `&search=${searchText}`;
        if (state) apiUrl += `&state=${state}`;
        if (zone) apiUrl += `&zone=${zone}`;
        if (branch) apiUrl += `&branch=${branch}`;
        const response = await fetch(
            apiUrl,
            options
        );
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/academic/sri-chaitanya/crm/landing-page");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchData = async (
        page: number,
        pageSize: number,
        searchText: string,
        state: number,
        zone: number,
        branch: number,
        agent: number,
        trainer: number,
    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData] = await Promise.all([
                fetchGroupsData(page, pageSize, searchText, state, zone, branch, agent, trainer),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setTotalCount(groupsData.total_count);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
            setToastMessage(groupsData.message || "submitted successfully!");
            setShowSuccessToast(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        // fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        // fetchData(currentPage, pageSize, value);
    };

    const updateBranchDetails = async (
        id: any,
        updateData: { [x: number]: any }
    ) => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(updateData),
        };
        const url = `${webApi}/branches/branch_details/${id}/`;
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error("Network response was not ok");
        }
    };

    const handleCheckboxChange = async (
        id: any,
        field: string,
        value: boolean
    ) => {
        const updateData = { [field]: value };
        try {
            await updateBranchDetails(id, updateData);
            // await fetchData(currentPage, pageSize, searchText);
        } catch (error) {
            console.error("Error updating branch details:", error);
        }
    };

    const handleSelect = (
        student_id: any,
        selectedRowKeys: string[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        const selectedIds = [...selectedRowKeys];
        const index = selectedIds.indexOf(student_id);
        if (index >= 0) {
            selectedIds.splice(index, 1);
        } else {
            selectedIds.push(student_id);
        }
        setSelectedRowKeys(selectedIds);
    };

    const handleSelectAll = (
        e: CheckboxChangeEvent,
        data: { id: any }[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        if (e.target.checked) {
            const allIds = data.map((item) => item.id);
            setSelectedRowKeys(allIds);
        } else {
            setSelectedRowKeys([]);
        }
    };

    const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setAgentsLoading(true);
        try {
            const endpoint = assignmentType === 'agent'
                ? `${webApi}/branches/assign_wizklub_agents_to_branches/`
                : `${webApi}/branches/assign_wizklub_trainers_to_branches/`;
            const response = await fetch(
                endpoint,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        branch_ids: selectedRowKeys,
                        leader_id: selectedAgent,
                        // target_date_: targetDate,
                    }),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                setDangerToastMessage(data.message);
                setShowSolidDangerToast(true);
                throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);
            setToastMessage(data.message);
            setshowSolidSuccessToast(true);
            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");
            setAsignShowCard(false);
            fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer)
            setAssignmentType(undefined);
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const handleSelectChange = (value: string[]) => {
        setSelectedAgent(value);
    };

    const handleExportClick = () => {
        let apiUrl = `${webApi}/wizklub/export_wizklub_branch_wise_interested_students_details/?token=${jwtToken}`;
        if (searchText) apiUrl += `&search=${searchText}`;
        if (selectedState) apiUrl += `&state=${selectedState}`;
        if (selectedZone) apiUrl += `&zone=${selectedZone}`;
        if (selectedBranch) apiUrl += `&branch=${selectedBranch}`;

        window.location.href = apiUrl;
    };

    useEffect(() => { fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer) }, [currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer])

    const columns = [
        // {
        //   title: "Action",
        //   dataIndex: "action",
        //   render: (_text: any, record: { id: any }) => (
        //     <Checkbox
        //       checked={selectedRowKeys.includes(record.id)}
        //       onChange={() =>
        //         handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
        //       }
        //     />
        //   ),
        //   key: "action",
        //   // align: "center",
        // },
        {
            title: (
                <span>
                    State{selectedState !== 0 ? ` (${states.find(state => state.state_id === selectedState)?.name})` : ""}
                    {selectedState !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearState}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "state_name",
            key: "state_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select State"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = states.find((s) => s.state_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedState(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {states.map((state) => (
                            <Select.Option key={state.state_id} value={state.state_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { state_name: string }) => record.state_name === value,

        },
        {
            title: (
                <span>
                    Zone{selectedZone !== 0 ? ` (${zones.find(zone => zone.zone_id === selectedZone)?.name})` : ""}
                    {selectedZone !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearZone}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "zone_name",
            key: "zone_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Zone"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = zones.find((z) => z.zone_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedZone(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {zones.map((zone) => (
                            <Select.Option key={zone.zone_id} value={zone.zone_id}>
                                {zone.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { zone_name: string }) => record.zone_name === value,
        },
        {
            title: (
                <span>
                    Branch{selectedBranch !== 0 ? ` (${branches.find(branch => branch.branch_id === selectedBranch)?.name})` : ""}
                    {selectedBranch !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearBranch}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "branch_name",
            key: "branch_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Select Branch"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = branches.find((b) => b.branch_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedBranch(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {branches.map((branch) => (
                            <Select.Option key={branch.branch_id} value={branch.branch_id}>
                                {branch.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
        },
        {
            title: "Agm",
            dataIndex: "agm"
        },
        {
            title: "Primary Details",
            dataIndex: "primary_school_student_count"
        },
        {
            title: "High School Details",
            dataIndex: "high_school_student_count"
        },
        // checkPermission("can_assign_wizklub_branch_detailes", "custom_model") ? {
        //   title: "Is Wizklub",
        //   dataIndex: "is_wizklub",
        //   render: (
        //     text: any,
        //     record: { id: any; is_wizklub: boolean | undefined }
        //   ) => (
        //     <input
        //       type="checkbox"
        //       name={`wizklub_${record.id}`}
        //       checked={record.is_wizklub}
        //       onChange={() =>
        //         handleCheckboxChange(record.id, "is_wizklub", !record.is_wizklub)
        //       }
        //     />
        //   ),
        // }: {},,

        // {
        //   title: "Is SummerCamp Lead",
        //   dataIndex: "is_summercamp_lead",
        //   render: (
        //     text: any,
        //     record: { id: any; is_summercamp_lead: boolean | undefined }
        //   ) => (
        //     <input
        //       type="checkbox"
        //       name={`wizklub_${record.id}`}
        //       checked={record.is_summercamp_lead}
        //       onChange={() =>
        //         handleCheckboxChange(record.id, "is_summercamp_lead", !record.is_summercamp_lead)
        //       }
        //     />
        //   ),
        // },

        // {
        //   title: "Is Offline",
        //   dataIndex: "is_offline",
        //   render: (text: any, record: { id: any; is_offline: boolean | undefined; }) => (
        //     <input
        //       type="checkbox"
        //       name={`offline_${record.id}`}
        //       checked={record.is_offline}
        //       onChange={() => handleCheckboxChange(record.id, 'is_offline', !record.is_offline)}
        //     />
        //   ),
        // },

    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Wizklub Branch Wise Intrested</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.adminDashboard1}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Wizklub Branch Wise Intrested
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {checkPermission("export_wizklubbranchwiseinterestedstudentsdetails", "wizklubbranchwiseinterestedstudentsdetails") && (
                                <button className="btn btn-primary me-2" onClick={handleExportClick} >
                                    Export
                                </button>
                            )}
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Branches List</h4>

                        </div>
                        <div className="card-body p-0 py-3">
                            {/* <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div> */}
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "20", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                    searchText={searchText}
                                />
                            )}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>


            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* /Delete Modal */}
            </>
        </div>
    );
};

export default WizklubBranchWiseIntrestedData;
